__turbopack_context__.v({
  "modal-body": "terms-privacy-modal-module-scss-module__u8Wpsa__modal-body",
  "modal-content": "terms-privacy-modal-module-scss-module__u8Wpsa__modal-content",
});
